import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

export const usePainterAccountMenuStyles = makeStyles<Theme>((theme) => ({
  '@keyframes slideDown': {
    from: { transform: 'translateY(-100%)' },
    to: { transform: 'translateY(0)' }
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    backgroundColor: 'rgba(37, 46, 61, 0.45)'
  },
  surface: {
    width: '100%',
    maxWidth: '100%',
    backgroundColor: theme.paintscout.palette.brand.Neutral.P30,
    boxShadow: '0 18px 40px rgba(37, 46, 61, 0.22)',
    animation: '$slideDown 0.25s cubic-bezier(0.2, 0, 0.2, 1)'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 2, 1.625),
    backgroundColor: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexShrink: 0
  },
  closeButton: {
    color: theme.palette.text.primary
  },
  title: {
    ...theme.typography.h4,
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightMedium
  },
  avatarBtn: {
    padding: 0,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '50%'
  },
  avatar: {
    width: 34,
    height: 34,
    borderRadius: '50%',
    objectFit: 'cover',
    backgroundColor: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightMedium
  },
  item: {
    width: '100%',
    minHeight: 52,
    display: 'grid',
    gridTemplateColumns: '40px 1fr',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    border: 0,
    color: theme.palette.common.white,
    backgroundColor: theme.paintscout.palette.brand.Neutral.P30,
    textAlign: 'left',
    cursor: 'pointer'
  },
  itemActive: {
    backgroundColor: theme.paintscout.palette.brand.Neutral.P40
  },
  itemDivider: {
    borderTop: `1px solid ${theme.paintscout.palette.brand.Neutral.P40}`
  },
  icon: {
    fontSize: 20
  },
  label: {
    fontSize: theme.typography.pxToRem(16),
    lineHeight: 1.2,
    letterSpacing: 0
  }
}))

export type PainterAccountMenuClasses = ReturnType<typeof usePainterAccountMenuStyles>
